import React, { useContext, useState } from 'react';
import { Typography, Grid, Stack } from '@mui/material';
import { LanguageContext } from '../../../../../../../../../libs/Context';

const RegisterDetails = (props) =>
{
	const { language } = useContext(LanguageContext);
	const [ showMore, setShowMore ] = useState(false);
	const { data } = props;
	const initialLines = 6;

	const renderText = () =>
	{
		const text = data?.meetingDetails?.description ?? '';

		if (!showMore)
		{
			const shortenedText = `${text.split('.').slice(0, initialLines)
				.join('.')}.`;

			return (
				<Typography>
					{shortenedText}
					<Typography component={'span'} style={{ cursor: 'pointer', color: 'var(--primaryColor)' }} onClick={() => setShowMore(true)} pl='var(--pixel8)'>
						{language?.readmore}
					</Typography>
				</Typography>
			);
		}
		else
		{
			return (
				<Typography>
					{text}
					<Typography component={'span'} style={{ cursor: 'pointer', color: 'var(--primaryColor)' }} onClick={() => setShowMore(false)}>
						{language?.readless}
					</Typography>
				</Typography>
			);
		}
	};

	return (

		<Grid container direction={'column'} spacing={1}>
			<Grid item pt='var(--pixel16)'>
				<Stack spacing={1}>
					<Typography fontSize={'var(--pixel18)'} sx={{ fontWeight: '500' }}>{language?.abtThisWebinar}</Typography>
					<Typography variant='subtitle1' color={'#585858'}>{renderText()}</Typography>
				</Stack>
			</Grid>
		</Grid>

	);
};

export default RegisterDetails;
